var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenShifts = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 30,
  viewBox: "0 0 34 30",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "4s8dgzvmaa",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFA990"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pz4k6vfbmb",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFA990"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "vyaobdmi8c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFA990"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e6ef46ywjd",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE9ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF1F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "xxp2vqdrne",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFA990"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "9b6cwlt0hf",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FC3A84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFA990"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-459 -24) rotate(-30 300.98 -838.104)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#4s8dgzvmaa)",
  d: "M2.343 12.47h5.236v3.308H2.343c-.762 0-1.378-.617-1.378-1.378v-.552c0-.76.616-1.378 1.378-1.378z",
  transform: "rotate(-90 4.272 14.124)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#pz4k6vfbmb)",
  d: "M4.272 5.512L16.446.738c.708-.278 1.508.07 1.786.78.063.16.095.33.095.502v12.357c0 .761-.617 1.378-1.378 1.378-.172 0-.343-.032-.503-.095L4.272 10.886V5.512z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#vyaobdmi8c)",
  d: "M1.378 5.512h1.653v5.374H1.378C.617 10.886 0 10.269 0 9.508V6.89c0-.761.617-1.378 1.378-1.378z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e6ef46ywjd)",
  d: "M2.894 5.512H4.272V10.886H2.894z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.134,
  height: 1.654,
  x: 20.826,
  y: 1.658,
  fill: "url(#xxp2vqdrne)",
  rx: 0.827,
  transform: "rotate(-15 22.893 2.485)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.236,
  height: 1.654,
  x: 22.185,
  y: 7.441,
  fill: "url(#9b6cwlt0hf)",
  rx: 0.827
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.134,
  height: 1.654,
  x: 20.826,
  y: 13.223,
  fill: "url(#xxp2vqdrne)",
  rx: 0.827,
  transform: "rotate(15 22.893 14.05)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenShifts);
export default ForwardRef;